<template>
  <div class="container" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="breadcrumb">
      <span class="currPage">促销员详情</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>基础中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: 'salespersonLibrary' }">促销员库</el-breadcrumb-item>
        <el-breadcrumb-item>促销员详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row class="clearfix" style="margin-bottom: 20px;">
      <el-col class="base-data left-data  leftBox">
        <div class="base-data-top">
          <div class="base-data-left floatl">
            <div class="avatar floatl" :style="avatarImg(salepersionData.headImg)" @click="showImage(salepersionData.headImg)">
              <img class="img" :src="salepersionData.headImg || ''" alt="" @error="setErrorImage" style="display: none">
            </div>
            <div class="name">
              <!-- {{hideName(salepersionData.name)}} -->
               {{salepersionData.name}} <span v-if="salepersionData.signContract" style="color: #1652ff; cursor: pointer; fontSize:8px; marginLeft:45px;fontWeight: 400;"
                    @click="openContractDialog(salepersionData.idcard, salepersionData.name)">已签约</span></div>
            <div class="persional-info">米咖ID:{{salepersionData.empPk}}</div>
            <div v-if="salepersionData && salepersionData.salesmanCode" class="persional-info">
                  水豚ID: {{ salepersionData.salesmanCode }}
            </div>
            <div class="persional-info">{{salepersionData.age}}岁<span class="line"></span>{{salepersionData.height}}cm</div>
            <div style="margin-left: 140px;" class="clearfix">
              <div class="status floatl" :class="{'on-guard': salepersionData.status=='项目中' || salepersionData.status=='在岗' }">{{salepersionData.status === '项目中' || salepersionData.status === '在岗' ? '项目中' : '待岗中'}}</div>
              <div class="tag floatl">
                <span class="tag-item" :class="{'long': true}" v-if="isLong">长</span>
                <span class="tag-item" v-if="isShort">短</span>
              </div>
            </div>
          </div>
          <div class="base-data-right floatr">
            <div class="title clearfix">
              基本信息
            </div>
            <a href="##" id="mask_box" class="data-item floatl" @click="createOutCall(salepersionData.empPk, salepersionData.name, salepersionData.originTel)"><img src="../../common/images/16dianhua.png" alt="">{{salepersionData.tel || '无'}}</a>
            <p class="data-item floatl" :title="
              ((salepersionData.province || '') +
              (salepersionData.city || '') +
              (salepersionData.area || '') +
              (salepersionData.homeAddress || '') || '无')
            ">
              <img src="../../common/images/15dizhi.png" alt="">{{
              ((salepersionData.province || '') +
              (salepersionData.city || '') +
              (salepersionData.area || '') +
              (salepersionData.homeAddress || '') || '无')
              }}
            </p>
            <p class="data-item floatl">认证状态：{{salepersionData.authenticationStatus}}</p>
            <p class="data-item floatl">银行卡认证状态：{{salepersionData.bankStatus}}</p>
            <p class="data-item floatl">项目数量：{{isShort ? ((salepersionData.projectCount || '0') + '个') : '- -'}}</p>
            <p class="data-item floatl">服务月数：{{ isLong ? ((salepersionData.serviceMonths || '0') + '个月') : '- -'}}</p>
            <p class="data-item floatl">紧急联系人：{{salepersionData.emergencyContact || '无'}}</p>
            <p class="data-item floatl">紧急联系人电话：{{salepersionData.emergencyTel || '无'}}</p>
          </div>
        </div>
        <div class="base-data-bottom clearfix">
          <div class="star floatl">
            <div class="star-level">星级：{{salepersionData.starName}}</div>
            <div class="progress">
              {{starName}}
              <div class="progress-line">
                <div class="bar" :style="'width: '+precent+'%;'"><div class="barText" v-if="mindifferenceScore!=null && poorScore!=null">{{mindifferenceScore}}/{{poorScore}}</div></div>
                <!-- 120 -->
              </div>
              {{nextstartName}}
            </div>
            <div class="view-btn" @click = "$router.push({path:'/SystemConfig',query:{navState:3}})">
              查看如何提升星级
            </div>
          </div>
          <div class="credit floatl">
            <div class="credit-num clearfix">
              <span class="floatl">{{salepersionData.creditScore}}</span>
              信用
            </div>
            <div class="view-btn" @click = "$router.push({path:'/SystemConfig',query:{navState:4}})">
              查看如何提升信用
            </div>
          </div>
          <div class="score floatl">
            <div class="score-num clearfix">
              <span class="floatl">{{salepersionData.score}}</span>
              积分
            </div>
            <div class="view-btn" @click = "$router.push({path:'/SystemConfig',query:{navState:2}})">
              查看如何获得积分
            </div>
          </div>
        </div>
      </el-col>
      <el-col class="right-data" :style="{'min-height':rightBoxHeight}">
        <el-row class="common-box">
          <div class="common-box-title">
            <h2>标签</h2>
          </div>
          <div class="common-box-body">
            <div class="tag-body">
              <el-tag class="tag-item" type="info" v-for="(item, index) in salepersionData.signName" :key="index">{{item}}</el-tag>
            </div>
          </div> 
        </el-row>
        <el-row class="common-box">
        <div class="common-box-title">
            <h2>自我喜好</h2>
          </div>
          <div class="common-box-body">
            <div class="tag-body">
              <el-tag class="tag-item" type="info" v-for="(item, index) in salepersionData.selfSignName" :key="index">{{item}}</el-tag>
            </div>
          </div>
          </el-row>
      </el-col>
    </el-row>
    <el-row class="common-box">
      <div class="common-box-title">
        <h2>米咖工作履历</h2>
      </div>
      <div class="common-box-body">
        <el-table ref="multipleTable" :data="tableData" size="small" border tooltip-effect="dark" style="width: 100%" header-row-class-name="table-header">
          <el-table-column label="编号" type="index" width="50" align="center"></el-table-column>
          <el-table-column prop="projectName" label="项目名" show-overflow-tooltip></el-table-column>
          <el-table-column prop="startTime" label="项目开始时间" width="120" align="center"></el-table-column>
          <el-table-column prop="endTime" label="项目结束时间" width="120" align="center"></el-table-column>
          <el-table-column prop="attendanceRate" label="考勤率" width="70" align="center"></el-table-column>
          <el-table-column prop="saleRate" label="销售达成" width="70" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.saleRate == null"> - </div>
              <div>{{scope.row.saleRate}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="qcScore" label="QC" width="70" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.qcScore == null"> - </div>
              <div>{{scope.row.qcScore}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="trainScore" label="培训得分" width="70" align="center"></el-table-column>
          <el-table-column prop="customerScore" label="客户评分" width="70" align="center"></el-table-column>
          <el-table-column prop="customerStar" label="客户星级" width="70" align="center"></el-table-column>
          <el-table-column prop="projectScore" label="项目组评分" width="90" align="center"></el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="slot, sizes, total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-row>
    <el-row class="common-box">
      <div class="common-box-title">
        <h2>水豚工作履历</h2>
      </div>
      <div class="common-box-body">
        <el-table ref="multipleTable" :data="tableDataSyn" size="small" border tooltip-effect="dark" style="width: 100%" header-row-class-name="table-header">
          <el-table-column label="编号" type="index" width="50" align="center"></el-table-column>
          <el-table-column prop="taskCode" label="任务编号" width="120" align="center"></el-table-column>
          <el-table-column prop="taskName" label="任务名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="taskStartTime" label="任务开始时间" width="120" align="center"></el-table-column>
          <el-table-column prop="taskEndTime" label="任务结束时间" width="120" align="center"></el-table-column>
          <el-table-column prop="taskRequire" label="任务要求" show-overflow-tooltip></el-table-column>
          <el-table-column prop="salaryDetail" label="服务费说明" show-overflow-tooltip></el-table-column>
          <el-table-column prop="taskDelegate" label="任务委托方" width="70" align="center"></el-table-column>
          <el-table-column prop="taskAssignmentTime" label="任务领取时间" width="160" align="center"></el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination"
          @size-change="handleSizeChangeSyn"
          @current-change="handleCurrentChangeSyn"
          :current-page="pageNoSyn"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSizeSyn"
          layout="slot, sizes, total, prev, pager, next, jumper"
          :total="totalSyn">
        </el-pagination>
      </div>
    </el-row>
    <div class="viewImage">
      <el-dialog
        title="查看大图"
        :visible.sync="showbigImage"
        v-model="bigImage"
        :width="bigImageWidth2"
        class="dialog"
        >
        <div  class="dialogImage" :style="avatarBigImg(bigImage)">
          <img  :src="bigImage || ''" alt="" @error="setErrorImage" style="display: none">
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" size="small" @click="showbigImage = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <el-dialog class="blacklistDialog dialog" :title="contractDialogTitle" :visible.sync="showContractDialog"
               width="75%" center v-loading="contractLoading">
      <el-form :inline="true" label-width="150px" class="formInline" size="mini">
        <div class="slide-wrap" style="height: auto;">
          <el-form-item label="合同开始时间">
            <el-date-picker value-format="yyyy-MM-dd" v-model="contractFormData.startTimeFrom"
                            type="date"></el-date-picker>
            -
            <el-date-picker value-format="yyyy-MM-dd" v-model="contractFormData.startTimeTo"
                            type="date"></el-date-picker>
          </el-form-item>
          <el-form-item label="合同结束时间：">
            <el-date-picker value-format="yyyy-MM-dd" v-model="contractFormData.endTimeFrom"
                            type="date"></el-date-picker>
            -
            <el-date-picker value-format="yyyy-MM-dd" v-model="contractFormData.endTimeTo" type="date"></el-date-picker>
          </el-form-item>
          <el-form-item label="客户名称：">
            <el-select v-model="contractFormData.customer" filterable placeholder="请选择...">
              <el-option label="不限" :value="null"></el-option>
              <el-option v-for="item in customerList" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签约平台：">
            <el-select v-model="contractFormData.serviceSupplier" filterable placeholder="请选择..." clearable>
              <el-option label="不限" :value="null"></el-option>
              <el-option label="薪太软" value="薪太软"/>
              <el-option label="众简" value="众简"/>
            </el-select>
          </el-form-item>
          <el-form-item style="float:right;margin-right: 50px;">
            <el-button class="search-btn" @click="searchContractData()">筛选</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="tableBody">
        <el-table class="table-expand" style="width: 100%;" size="small" border :data="contractData">
          <el-table-column type="index" label="编号" align="center"/>
          <el-table-column prop="customer" label="签约客户" align="center"/>
          <el-table-column prop="merchantName" label="供应商" align="center"/>
          <el-table-column prop="signTime" label="签约时间" align="center"/>
          <el-table-column prop="startTime" label="合同开始时间" align="center"/>
          <el-table-column prop="endTime" label="合同结束时间" align="center"/>
          <el-table-column prop="serviceSupplier" label="签约平台" align="center"/>
        </el-table>
        <el-pagination class="pagination table-pagination" @size-change="handleContractSizeChange"
                       @current-change="handleContractCurrentChange" :current-page="contractFormData.pageNo"
                       :page-sizes="[10, 20, 50, 100]" :page-size="contractFormData.pageSize"
                       layout="slot,sizes, total,  prev, pager, next, jumper" :total="contractTotal">
        </el-pagination>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import avatarDefault from 'common/images/avatar-default.png'
import utils from '../../common/js/util.js'
export default {
  name: 'salespersonDetail',
  data() {
    return {
      isAdmin:false,//是否是tinashi或者admin1

      pageNo: 1,
      pageSize: 10,
      pageNoSyn: 1,
      pageSizeSyn: 10,
      total: null,
      totalSyn:null,
      starValue: null,
      salepersionData: {
        headImg: ''
      },
      tableData: [],
      tableDataSyn: [],
      addScore: '',
      addStar: '',
      addCredit: '',
      loading: false,
      isLong: false,
      isShort: false,

      avatarDefault: avatarDefault,
      showbigImage: false,
      bigImage:null,
      bigImageWidth:null,
      bigImageHeight:null,
      bigImageWidth2:null,

      startName:null,
      nextstartName:null,
      precent:null,
      mindifferenceScore:null,
      poorScore: null,
      starName:null,
      // 项目所有客户
        customerList: [],
        // 显示签约合同记录
        showContractDialog: false,
        contractDialogTitle: null,
        contractLoading: false,
        // 签约合同记录筛选条件
        contractFormData: {
          pageNo: 1,
          pageSize: 10,
          startTimeFrom: null,
          startTimeTo: null,
          endTimeFrom: null,
          endTimeTo: null,
          customer: null,
          serviceSupplier: null
        },
        contractTotal: null,
        contractData: null,
        // auths:[]
        rightBoxHeight:'270px'//右侧盒子的高度动态获取和左侧一样高
    };
  },
  created(){
    //不知道干啥的。。
    // for (let i = 0; i < this.$route.query.auths.length; i++) {
    //   this.auths.push (parseInt(this.$route.query.auths[i]))
    // }
    // console.log(this.auths)
  },
  mounted () {
    this.rightBoxHeight=document.querySelector('.leftBox').clientHeight+'px'
    let user = sessionStorage.getItem('user')
    this.isAdmin = Boolean(user == 'admin1' || user == 'tinashi')

    this.loading = true
    this.$http({
      method:"POST",
      url:'/rest/SalesmanParticulars/basicInformation',
      params: {
        id: this.$route.query.id
        // id:'wwwww'
      }
    }).then(res => {
      let data = res.data
      if(!this.isAdmin){
        data.originTel = data.tel;
        data.tel = utils.plusXing(data.tel,3,4);
      }
      data.emergencyTel = utils.plusXing(data.emergencyTel,3,4);
      this.salepersionData = data
      this.salepersionData.idcard = data.idcard
      let join = this.salepersionData.signName.join();
      if (join.indexOf('不限') >= 0){
        this.isLong = true;
        this.isShort = true;
      }else{
        this.isLong = join.indexOf('长促') >= 0
        this.isShort = join.indexOf('短促') >= 0
      }
      this.starValue = data.starScore / 10000 * 5
      this.getTableData()
      this.getTableDataSyn()
      this.loading = false

      this.$http({
        method:"GET",
        url:"/rest/SearchScoreDetails/searchNextStartName",
        params:{
          score:this.salepersionData.starScore
        }
      }).then(res=>{
          let data1 = res.data
          this.starName = data1.startName
          this.nextstartName = data1.nextstartName
          this.mindifferenceScore = data1.mindifferenceScore
          this.poorScore = data1.poorScore
          this.precent = ( data1.mindifferenceScore / data1.poorScore ) * 100
      })
    }).catch(()=>{
      this.loading = false
    })

    this.searchAllCustomer();
  },
  methods: {
    returnName(name){
        if(this.isAdmin){
            return name
        } else {
            return utils.plusXing(name,1,1)
        }

    },
    hideName(val){
      console.log(val)
      let a = val[0]
      if(this.isAdmin){
        return val
      } else {
        for(let i = 0; i <val.length-1;i++){
          a = a + '*'
        }
        return a
      }
    },
    avatarImg(url){
      if( url != null ){
        return {
          backgroundImage:'url('+url+')',
          backgroundSize:'cover',
          width:'110px',
          height:'110px',
        }
      }else{
        return {
          backgroundImage:'url('+this.avatarDefault+')',
          backgroundSize:'cover',
          width:'110px',
          height:'110px',
        }
      }

    },
    avatarBigImg(url){
      if( url != null ){
        return {
          backgroundImage:'url('+url+')',
          backgroundSize:'cover',
          width:this.bigImageWidth,
          height:this.bigImageHeight
        }
      }else{
        return {
          backgroundImage:'url('+this.avatarDefault+')',
          backgroundSize:'cover',
          width:this.bigImageWidth,
          height:this.bigImageHeight
        }
      }

    },
    dialogWidth(){
      return {
        width: this.bigImageWidth
      }
    },
    showImage(url){
      this.showbigImage = true;
      this.bigImage = url
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.getTableData()
    },
    handleSizeChangeSyn (val2) {
      this.pageSizeSyn = val2
      this.getTableDataSyn()
    },
    handleCurrentChangeSyn (val2) {
      this.pageNoSyn = val2
      this.getTableDataSyn()
    },
    getTableData () {
      this.$http({
        method: 'POST',
        url: '/rest/CrmWorkExperience/list',
        params: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          idCard: this.salepersionData.idcard
        }
      }).then(res => {
        this.tableData = res.data
        this.rightBoxHeight=document.querySelector('.leftBox').clientHeight+'px'
      })

      this.$http({
        method: 'POST',
        url: '/rest/CrmWorkExperience/countCrmWorkExperience',
        params: {
          // pageNo: this.pageNo,
          // pageSize: this.pageSize,
          idCard: this.salepersionData.idcard || 1
        }
      }).then(res => {
        this.total = Number(res.data)
      })
    },

    getTableDataSyn () {
      this.$http({
        method: 'POST',
        url: '/rest/CrmSynRest/findCrmWorkExperience',
        params: {
          pageNo: this.pageNoSyn,
          pageSize: this.pageSizeSyn,
          id: this.$route.query.id
        }
      }).then(res => {
        this.tableDataSyn = res.data
        this.rightBoxHeight=document.querySelector('.leftBox').clientHeight+'px'
      })

      this.$http({
        method: 'POST',
        url: '/rest/CrmSynRest/countCrmWorkExperience',
        params: {
          // pageNo: this.pageNo,
          // pageSize: this.pageSize,
          id: this.$route.query.id 
        }
      }).then(res => {
        this.totalSyn = Number(res.data)
      })
    },

    // 图片出错
    setErrorImage (event) {
      event.target.parentNode.style.backgroundImage = `url(${this.avatarDefault})`
    },


    // 查看操作
    // viewEnhance(){
    //   this.
    // }

    // 虚拟拨号
    createOutCall(salesmanId, salesmanName, salesmanTel) {
      // 获取当前用户虚拟电话配置
      this.$http({
        method: 'get',
        url: '/rest/JiangYiJoint/dummy-config',
        params: {
          sysUserId: sessionStorage.getItem("sysUserId")
        }
      }).then(res => {
        if(res.data.status == '200' && res.data.data) {
          let config = res.data.data;
          // 拨打虚拟电话
          var ajaxdata = {
            city: null,
            cityCode: null,
            county: null,
            countyCode: null,
            empPK: config.phoneUserEmpPk,
            module: "促销员库",
            phoneUserCode: config.phoneUserCode,
            phoneUserName: config.phoneUserName,
            projectBU: null,
            projectCode: null,
            projectName: null,
            province: null,
            provinceCode: null,
            salesId: salesmanId,
            salesName: salesmanName,
            storeCode: null,
            storeName: null,
            ivr: {called: salesmanTel, caller: config.phoneNumber}
          }
          var xhrs2 = new XMLHttpRequest();
          xhrs2.onreadystatechange = function () {
            if (xhrs2.readyState == 4) {
              if (xhrs2.status == 200) {
                // 成功不做任何事
                document.getElementById('mask_box').disabled = true;
                setTimeout(function () {
                  document.getElementById('mask_box').disabled = false;
                }, 5000);
                alert("号码呼叫中....");
              } else {
                var str = JSON.parse(xhrs2.responseText);
                document.getElementById('mask_box').disabled = true;
                setTimeout(function () {
                  document.getElementById('mask_box').disabled = false;
                }, 5000);
                alert(str.msg);
              }
            }
          }
          var callurl = this.globalParams.remotesUrl + "/plugs/phoneCall/createOutCall";
          xhrs2.open('POST', callurl, true);
          xhrs2.setRequestHeader("Content-type", "application/json");
          xhrs2.send(JSON.stringify(ajaxdata));
        } else {
          alert("当前账号未配置虚拟拨号");
          console.log(res.data);
        }
      }).catch(err => {
        console.log(err);
      });
    }
    ,
      // 查询所有项目客户
      searchAllCustomer() {
        this.$http({
          method: 'GET',
          url: '/rest/baseCenter/all-customers'
        }).then(res => {
          this.customerList = res.data.data
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      }
    ,
  openContractDialog(idcard, salesmanName) {
        this.contractDialogTitle = salesmanName;
        this.contractFormData.idcard = idcard;
        this.showContractDialog = true;
        this.searchContractData();
      },
      searchContractData() {
        this.contractFormData.pageNo = 1;
        this.contractFormData.pageSize = 10;
        this.contractLoading = true;
        this.$http({
          method: 'GET',
          url: '/rest/baseCenter/contract-history',
          params: this.contractFormData
        }).then(res => {
          this.contractData = res.data.data.items;
          this.contractTotal = res.data.data.totalItemsCount;
          this.contractLoading = false;
        }).catch(err => {
          this.contractLoading = false;
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      }
  },
  updated(){
      let width = document.getElementsByClassName('img')[0].width
      let height = document.getElementsByClassName('img')[0].height
      width > 500 ?  (width = width / 2 ,height = height / 2) : (width,height)
      width < 300 ?  (width = 300 ,height = 300) : (width,height)
      this.bigImageWidth = width + 'px';
      this.bigImageWidth2 = width + 40 +'px';
      this.bigImageHeight = height + 'px';
  }
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/variable.scss";
// 查看大图
.dialog{
  .dialogImage{
    // padding: 20px;
    img{
      opacity: 0;
    }
  }
}

.base-data {
  width: 800px;
  // height: 270px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 15px 20px 20px;
  .base-data-top{
    width: 100%;
    // height: 120px;
    overflow: hidden;
  }
  .base-data-bottom{
    width: 100%;
    height: 100px;
    margin-top: 20px;
  }
  .base-data-left {
    width: 280px;
    height: 120px;
    border-right: 1px solid #f4f4f4;
    box-sizing: border-box;
    .avatar {
      height: 110px;
      border-radius: 50%;
      img {
        border-radius: 50%;
        opacity: 0;
      }
    }
    .name {
      font-size: 15px;
      font-weight: bold;
      color: $theme-font-color;
      line-height: 1em;
      margin-top: 20px;
      margin-left: 140px;
    }
    .persional-info {
      margin-top: 12px;
      margin-left: 140px;
      height: 15px;
      line-height: 15px;
      color: #999;
      .line {
        display: inline-block;
        width: 1px;
        height: 15px;
        background: #999;
        margin: 0 10px;
        vertical-align: top;
      }
    }
    .status {
      display: inline-block;
      padding: 0 8px;
      height: 18px;
      margin-top: 10px;
      border-radius: 9px;
      background: #a9cfaa;
      color: #fff;
      line-height: 18px;
      font-size: 12px;
      margin-right: 5px;
      &.on-guard {
        background: $theme-color;
      }
    }
    .tag{
      height: 18px;
      margin-top: 10px;
      .tag-item {
        display: inline-block;
        width: 18px;
        height: 18px;
        background: #80bd81;
        border-radius: 50%;
        text-align: center;
        margin-left: 5px;
        color: #fff;
        font-size: 12px;
        &.long {
          background: #8299dc;
        }
      }
    }
  }
  .base-data-right {
    width: 460px;
    .title {
      height: 18px;
      line-height: 18px;
      font-size: 14px;
      color: #4e4e4e;
      margin: 10px 0;
    }
    .data-item {
      font-size: 14px;
      color: #999;
      line-height: 26px;
      &:nth-of-type(2n+1){
         width: 190px;
      }
      &:nth-of-type(2n){
        width: 270px;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
      }
      i{
        color: $color-green;
        margin-right: 3px;
      }
    }
  }
  .points {
    width: 240px;
    height: 100px;
    background: #f8f8f8;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 20px;
    .chart{
      margin: 20px 0 10px;
      line-height: 14px;
      .text{
        color: #333;
      }
      .point-progress{
        width: 100%;
      }
      .num{
        color: #999;
        span{
          font-size: 16px;
          color: #f7904b;
        }
      }
    }
    .progress-line{
      width: 200px;
      height: 12px;
      display: inline-block;
      background: #e2e2e2;
      border-radius: 6px;
      margin: 0 auto;
      .bar{
        height: 12px;
        border-radius: 6px;
        display: inline-block;
        background: linear-gradient(to right, #b7c5f6, #849cda);
        display: flex;
        color:#2d2c7a;
      }
    }
  }
  .star {
    width: 240px;
    height: 100px;
    background: #f8f8f8;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    margin-right: 20px;
    .star-rate {
      height: 20px;
      margin-top: 10px;
      text-align: center;
    }
    .star-level {
      height: 40px;
      color: #333;
      line-height: 40px;
      font-size: 12px;
      text-align: center;
    }
    .progress{
      width: 100%;
      height: 12px;
      line-height: 12px;
      text-align: center;
      font-size: 12px;
      color: #999;
      .progress-line{
        width: 140px;
        height: 12px;
        display: inline-block;
        background: #e2e2e2;
        border-radius: 6px;
        margin: 0 5px;
        color: #fb642d;
        text-align: left;
        .bar{
          height: 12px;
          border-radius: 6px;
          display: inline-block;
          background: linear-gradient(to right, #f8b332, #f79355);
          color:#2d2c7a;
          .barText{
            position: absolute;
            left:42%
          }
        }
      }
    }
  }
  .credit {
    width: 240px;
    height: 100px;
    background: #f8f8f8;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    margin-right: 20px;
    .credit-num {
      line-height: 70px;
      font-size: 14px;
      color: $theme-color;
      text-align: right;
      padding: 0 40px;
      span {
        color: #f7904b;
        font-size: 32px;
        font-weight: bold;
      }
    }
  }
  .score {
    width: 240px;
    height: 100px;
    background: #f8f8f8;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    .score-num {
      line-height: 70px;
      font-size: 14px;
      color: $theme-color;
      text-align: right;
      padding: 0 40px;
      span {
        color: #f7904b;
        font-size: 32px;
        font-weight: bold;
      }
    }
  }
  .view-btn {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    box-sizing: border-box;
    padding-right: 10px;
    color: #999;
    cursor: pointer;
    border-top: 1px solid #fff;
    // 暂时去掉
    // &:hover {
    //   border-top: none;
    //   background: $theme-light-color;
    //   color: #fff;
    // }
  }
}
.right-data{
  width: calc(100% - 810px);
  height: 270px;
  margin-left: 10px;
  background: #fff;
  border-radius: 5px;
  overflow-x: hidden;
  overflow-y: auto;
}
.tag-body {
  padding: 10px 0;
  .tag-item {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/personnelCenter/salespersonDetail.vue